module.exports = __webpack_public_path__ + "static/media/three-dots-dark.f4dee109.svg";